import { create } from "zustand";
import { persist } from "zustand/middleware";

import { appearanceStore } from "@/stores/appearance";

import { HalloweenModeStore } from "@/types";

export const halloweenModeStore = create<HalloweenModeStore>()(
  persist(
    (set) => ({
      isHalloweenMode: true,
      toggleHalloweenMode: () => {
        if (!halloweenModeStore.getState().isHalloweenMode) {
          appearanceStore.setState({ isDarkMode: true });
        }
        set((state) => ({ isHalloweenMode: !state.isHalloweenMode }));
      },
    }),
    { name: "halloween-mode" },
  ),
);
